import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SearchBar from "./components/SearchBar";
import FindClinic from "./components/FindClinic";

const queryClient = new QueryClient();

const searchRootNode = document.querySelectorAll(".js-search-root");

if (searchRootNode) {
    searchRootNode.forEach((element) => {
        const searchRoot = ReactDOM.createRoot(element);
        searchRoot.render(
            <QueryClientProvider client={queryClient}>
                <SearchBar />
            </QueryClientProvider>
        );
    });
}

const findClinicRootNode = document.getElementById("find-a-clinic-root");

if (findClinicRootNode) {
    const findClinicRoot = ReactDOM.createRoot(findClinicRootNode);
    findClinicRoot.render(
        <QueryClientProvider client={queryClient}>
            <FindClinic />
        </QueryClientProvider>
    );
}
